import { useState, useEffect, useCallback } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { addDays, subDays } from "date-fns";
import { CourtGridTimeSlot } from "../../../models/CourtGridData";

export default function useWeeklyUI() {
  const isMobile = useMediaQuery("(max-width: 980px)");

  const [startDate, setStartDate] = useState<Date>(new Date());
  const [reservationModal, setReservationModal] = useState<{
    isOpen: boolean;
    exerciseId: number | null;
  }>({
    isOpen: false,
    exerciseId: null,
  });

  const handleSlotClick = useCallback((timeSlot: CourtGridTimeSlot) => {
    setReservationModal({
      isOpen: true,
      exerciseId: timeSlot.exerciseId,
    });
  }, []);

  const handleCloseReservationModal = useCallback(() => {
    setReservationModal({
      isOpen: false,
      exerciseId: null,
    });
  }, []);

  const handlePreviousPeriod = useCallback(() => {
    setStartDate((prev) => (isMobile ? subDays(prev, 1) : subDays(prev, 7)));
  }, [isMobile]);

  const handleNextPeriod = useCallback(() => {
    setStartDate((prev) => (isMobile ? addDays(prev, 1) : addDays(prev, 7)));
  }, [isMobile]);

  // Reset to today when mobile/desktop changes
  useEffect(() => {
    setStartDate(new Date());
  }, [isMobile]);

  return {
    isMobile,
    startDate,
    setStartDate,
    reservationModal,
    handleSlotClick,
    handleCloseReservationModal,
    handlePreviousPeriod,
    handleNextPeriod,
  };
}

